// extracted by mini-css-extract-plugin
export var dismissOverlay = "_fr-b";
export var interactivePassthrough = "_fr-3";
export var modal = "_fr-d";
export var modalBackdrop = "_fr-c";
export var modalBody = "_fr-j";
export var modalDescription = "_fr-m";
export var modalEnter = "_fr-e";
export var modalFooter = "_fr-n";
export var modalHeaderText = "_fr-h";
export var modalIconCircle = "_fr-i";
export var modalIconHeader = "_fr-g";
export var modalImage = "_fr-f";
export var modalSectionLabel = "_fr-k";
export var modalTitle = "_fr-l";
export var pulse = "_fr-1";
export var pulseBorder = "_fr-2";
export var spotlight = "_fr-0";
export var tooltip = "_fr-4";
export var tooltipButtons = "_fr-9";
export var tooltipDescription = "_fr-6";
export var tooltipFooter = "_fr-7";
export var tooltipInteractivePill = "_fr-a";
export var tooltipStepIndicator = "_fr-8";
export var tooltipTitle = "_fr-5";